// @flow

import React from "react";
import { localize } from "redux-i18n";
import http from "@http";
import { Button, Form, FormGroup, Label } from "@components";
import { reduxForm, Field } from "redux-form";
import type { FormProps } from "redux-form";
import { getSchema } from "@utils/schema";
import { DatePickerFormWrapper, Dropdown } from "@components/form";
import moment from "moment";
import { MEDICAL } from "@modules/shared/constants/employee-absences";
import config from "@config";
const schema = getSchema("EmployeeAbsenceStatisticsFiltersDTO");

type Props = $Exact<{
  onSubmit: () => void,
  initialize: Function,
  ...PropsFromLocalize,
  ...$Exact<FormProps>, // https://stackoverflow.com/a/44771268/220839
}>;

export class AbsenceStatisticsFilter extends React.Component<Props> {
  resetForm = () => {
    this.props.reset();
    this.props.handleSubmit();
  };

  get absenceTypeOptions() {
    return ((((schema || {}).properties || {}).absenceTypes || {}).items || {}).oneOf.map(item => ({
      value: item.const,
      label: item.title,
    }));
  }

  UNSAFE_componentWillMount() {
    const options = this.absenceTypeOptions.map(i => i.value);
    const val = {
      toDate: moment().format("YYYY-MM-DD"),
      fromDate: moment()
        .subtract(1, "years")
        .format("YYYY-MM-DD"),
      absenceType: options.length ? options[0] : MEDICAL,
    };
    this.props.initialize(val);
  }

  render() {
    return (
      <Form onSubmit={this.props.handleSubmit} className="d-flex">
        <FormGroup className="col-3 p-0 mr-3">
          <Label for="fromDate">{this.props.t("DATE_FROM")}</Label>
          <Field
            name="fromDate"
            component={DatePickerFormWrapper}
            customProps={{ dateFormat: config.dateFormatBE, id: "fromDate" }}
          />
        </FormGroup>
        <FormGroup className="col-3 p-0 mr-3">
          <Label for="toDate">{this.props.t("DATE_TO")}</Label>
          <Field
            name="toDate"
            component={DatePickerFormWrapper}
            customProps={{ dateFormat: config.dateFormatBE, id: "toDate" }}
          />
        </FormGroup>
        <FormGroup className="col-3 p-0 mr-3">
          <Label for="absenceType">{this.props.t("ABSENCE_TYPE")}</Label>
          <Field
            id="absenceType"
            name="absenceType"
            component={Dropdown}
            options={this.absenceTypeOptions}
          />
        </FormGroup>
        <div className="d-flex align-bottom pt-4">
          <Button materialIcon="replay_circle_filled">{this.props.t("SUBMIT")}</Button>
          {this.props.dirty ? (
            <Button color="secondary" onClick={this.resetForm}>
              {this.props.t("RESET")}
            </Button>
          ) : null}
        </div>
      </Form>
    );
  }
}

export default reduxForm({
  form: "absence-statistics-filters",
})(localize()(AbsenceStatisticsFilter));
